import { unreachable } from '@/std/util';

export enum EmpresaSistemaTipoUso {
    Completo = 'C',
    Financeiro = 'F',
}

export enum EmpresaSistemaTipoUsoDesc {
    C = 'Completo',
    F = 'Financeiro',
}

export enum EmpresaSituacao {
    Aprovada = 1,
    Pendente = 2,
    Bloqueada = 3,
    Demonstracao = 4,
}

export function empresaSituacaoToString(situacao: EmpresaSituacao): string {
    switch (situacao) {
        case EmpresaSituacao.Aprovada:
            return 'Aprovada';
        case EmpresaSituacao.Bloqueada:
            return 'Bloqueada';
        case EmpresaSituacao.Pendente:
            return 'Pendente';
        case EmpresaSituacao.Demonstracao:
            return 'Demonstração';
        default:
            unreachable(situacao);
    }
}

export enum EmpresaTipoEmissao {
    Normal = 1,
    Contingencia = 2,
}

export enum EmpresaMicro {
    Padrao = 0,
    Sim = 1,
    Nao = 2,
}

export enum EmpresaPermiteCredito {
    Sim = 1,
    Nao = 2,
}

export enum EmpresaCrtCrt {
    SimplesNacional = 1,
    SimplesNacionalExcesso = 2,
    RegimeNormal = 3,
    Mei = 4,
    Outro = 5,
}

/** Se é para descontar o valor do funrural do total do item da nf-e */
export enum EmpresaImpostoFunruralDescontar {
    Sim = 1,
    Nao = 2,
}
